import Vue from 'vue'
export default (function () {
  Vue.filter('status', function (value) {
    if (value == 1) {
      return '启用'
    } else if (value == 0) {
      return '禁用'
    } else {
      return '未知状态'
    }
  })
  Vue.filter('rules', function (value) {
    return value
  })
  Vue.filter('toDate', function (value) {
    return moment.unix(value).format('YYYY-MM-DD')
  })
  Vue.filter('toTime', function (value) {
    return moment.unix(value).format('YYYY-MM-DD HH:mm')
  })
  Vue.filter('spendTime', function (value) {
    if (typeof value != 'number') {
      return '无效时间'
    }
    if (value > 3600) {
      let time = (value / 3600).toString()
      let index_ = time.indexOf('.')
      const hour = time.substr(0, index_)
      const min = parseInt(parseFloat('0' + time.substr(index_, 3)) * 60)
      return '耗时' + hour + '小时' + min + '分钟'
    } else {
      return '耗时' + parseInt(value / 60) + '分钟'
    }
  })
  Vue.filter('operation', function (value) {
    let name = ''
    switch (value) {
      case 10:
        name = '列表'
        break
      case 20:
        name = '添加/编辑/详情'
        break
      case 30:
        name = '编辑'
        break
      case 40:
        name = '详情'
        break
      case 50:
        name = '删除'
        break
      case 60:
        name = '导入'
        break
      case 70:
        name = '导出'
        break
      case 80:
        name = '搜索'
        break
      case 90:
        name = '一键修改字段值'
        break
      case 100:
        name = '筛选标签'
        break
      case 110:
        name = '下载'
        break
      case 120:
        name = '消息提醒'
        break
      case 130:
        name = '图表'
        break
      case 140:
        name = '字段拓展管理'
        break
      case 150:
        name = '执行函数'
        break
      case 160:
        name = '外部链接iframe'
        break
      case 170:
        name = '导出word文档'
        break
      case 180:
        name = '定制化功能点'
        break
      case 190:
        name = '批量添加子数据'
        break
      case 200:
        name = '批量编辑'
        break
      case 210:
        name = '一维统计图表'
        break
      case 220:
        name = '功能点链接集合'
        break
      case 230:
        name = '发邮件'
        break
      default :
        name = '未知操作'
    }
    return name
  })
  Vue.filter('widget', function (value) {
    let name = ''
    switch (value) {
      case 10:
        name = '输入框'
        break
      case 20:
        name = '下拉框'
        break
      case 30:
        name = '范围搜索'
        break
      case 40:
        name = '时间搜索'
        break
      case 50:
        name = '外键下拉框'
        break
      case 60:
        name = '复选框'
        break
      case 70:
        name = '外键复选框'
        break
      default :
        name = '无需渲染'
    }
    return name
  })
  Vue.filter('position', function (value) {
    let pos = ''
    switch (value) {
      case 10:
        pos = '左上'
        break
      case 20:
        pos = '右上'
        break
      case 30:
        pos = '左下'
        break
    }
    return pos
  })
  Vue.filter('menuType', function (value) {
    let type = ''
    switch (value) {
      case 1:
        type = '三级菜单'
        break
      case 2:
        type = '单页菜单'
        break
    }
    return type
  })
  Vue.filter('moduleType', function (value) {
    let module = ''
    switch (value) {
      case 10:
        module = '公共模块'
        break
      case 20:
        module = '私有模块'
        break
    }
    return module
  })
  Vue.filter('anyDate', function(value, unit) {
    let dateType = ''
    switch (unit) {
      case 10:
        dateType = 'YYYY'
        break
      case 20:
        dateType = 'YYYY-MM'
        break
      case 30:
        dateType = 'YYYY-MM-DD'
        break
      case 40:
        dateType = 'YYYY-MM-DD HH'
        break
      case 50:
        dateType = 'YYYY-MM-DD HH:mm'
        break
      case 60:
        dateType = 'YYYY-MM-DD HH:mm:ss'
        break
    }
    return moment.unix(value).format(dateType)
  })
  Vue.filter('contentShowType', function(value) {
    let type = ''
    switch (value) {
      case 10:
        type = '一般'
        break
      case 20:
        type = 'Tab'
        break
      default:
        type = '未知'
        break
    }
    return type
  })
  Vue.filter('inputTypeData', function(value) {
    let type = ''
    switch (value) {
      case 10:
        type = '单行文本控件'
        break
      case 20:
        type = '密码控件'
        break
      case 30:
        type = '多行文本控件'
        break
      case 40:
        type = '单选框控件'
        break
      case 50:
        type = '多选框控件'
        break
      case 60:
        type = '下拉框控件'
        break
      case 70:
        type = '日期控件'
        break
      case 80:
        type = '日期时间控件'
        break
      case 90:
        type = '时间控件'
        break
      case 100:
        type = '编辑器'
        break
      case 110:
        type = '级联控件'
        break
      case 120:
        type = '外键控件'
        break
      case 130:
        type = '子表单控件'
        break
      case 140:
        type = '文件上传控件'
        break
      case 150:
        type = '人员选择控件'
        break
      case 160:
        type = '部门选择控件'
        break
      case 170:
        type = '获取用户信息控件'
        break
      case 180:
        type = '获取系统时间控件'
        break
      case 190:
        type = '字段扩展管理控件'
        break
      case 200:
        type = '多对多控件'
        break
      case 210:
        type = '图片'
        break
      case 220:
        type = '子表关联'
        break
      case 230:
        type = '接口获取内容'
        break
    }
    return type
  })
})()



// WEBPACK FOOTER //
// ./src/assets/js/filter.js